// import React from 'react'&#10;import { Helmet } from 'react-helmet-async'&#10;import ContactForm from '@/components/ui/ContactPage/ContactForm'&#10;// import StoreLocations from '@/components/ui/ContactPage/StoreLocations'&#10;import InstagramGrid from '@/components/ui/Homepage/InstagramFeed'&#10;import StoresInfo from "@/components/ui/Homepage/StoresInfo/StoresInfo";&#10;&#10;const Contact = () => {&#10;  return (&#10;    <>&#10;      <Helmet>&#10;        <title>Contact Bakelore - Bakery Locations in Hyderabad</title>&#10;        <meta name="description" content="Contact Bakelore Hyderabad bakery. Madhapur store locations, phone, WhatsApp, contact form for cake orders." />&#10;        <meta property="og:title" content="Contact Bakelore - Hyderabad" />&#10;        <meta property="og:description" content="Reach Bakelore stores in Hyderabad. Contact form, phone, email for cakes, desserts, hampers." />&#10;        <meta property="og:image" content="https://bakelore.com/images/bakelore-store.jpg" />&#10;        <meta property="og:url" content="https://bakelore.com/contact" />&#10;      </Helmet>&#10;    <div>&#10;     {/* <StoreLocations/> */}&#10;      <StoresInfo />&#10;     <ContactForm/>&#10;     <InstagramGrid/>&#10;    </div>&#10;    </>&#10;  )&#10;}&#10;&#10;export default Contact
import React from "react";
import { Helmet } from "react-helmet-async";

import ContactForm from "@/components/ui/ContactPage/ContactForm";
import InstagramGrid from "@/components/ui/Homepage/InstagramFeed";
import StoresInfo from "@/components/ui/Homepage/StoresInfo/StoresInfo";

const Contact = () => {
  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>
          Contact Bakelore Bakery Hyderabad | Madhapur Cake Shop Phone, Address
        </title>

        <meta
          name="description"
          content="Contact Bakelore bakery in Madhapur, Hyderabad. Call, WhatsApp or visit our store for birthday cakes, custom cakes, desserts and hampers."
        />

        <meta
          name="keywords"
          content="Bakelore contact number, bakery Madhapur Hyderabad, cake shop Hyderabad contact, custom cakes Hyderabad contact"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Contact Bakelore | Best Bakery in Hyderabad"
        />

        <meta
          property="og:description"
          content="Reach Bakelore bakery in Madhapur, Hyderabad. Contact us for custom cakes, birthday cakes and dessert orders."
        />

        <meta
          property="og:image"
          content="https://bakelore.com/images/bakelore-store.jpg"
        />

        <meta property="og:url" content="https://bakelore.com/contact" />
        <meta property="og:type" content="website" />

        {/* Twitter Preview */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Bakelore Bakery Hyderabad"
        />
        <meta
          name="twitter:description"
          content="Visit Bakelore bakery Madhapur or contact us for cakes, desserts and hampers."
        />
        <meta
          name="twitter:image"
          content="https://bakelore.com/images/bakelore-store.jpg"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://bakelore.com/contact" />

        {/* Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Bakery",
            name: "Bakelore",
            image: "https://bakelore.com/images/bakelore-store.jpg",
            url: "https://bakelore.com/contact",
            telephone: "+91-XXXXXXXXXX",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Madhapur",
              addressLocality: "Hyderabad",
              addressRegion: "Telangana",
              postalCode: "500081",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "17.4483",
              longitude: "78.3915",
            },
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ],
                opens: "10:00",
                closes: "22:00",
              },
            ],
            sameAs: [
              "https://www.instagram.com/bakelore",
              "https://www.facebook.com/bakelore",
            ],
          })}
        </script>
      </Helmet>

      <div>
        <StoresInfo />
        <ContactForm />
        <InstagramGrid />
      </div>
    </>
  );
};

export default Contact;